import { useEffect } from 'react'
import { floraMessage } from '@grupoboticario/flora-react-utils'
import { FloraTypographyProps } from './types'

export const useFloraTypography = (children: React.ReactNode) => {
  useEffect(() => {
    if (typeof children === 'string' && children.length > 80) {
      floraMessage({
        type: 'log',
        category: 'accessibility',
        status: 'warn',
        message: `O texto do componente FloraTypography possui mais de 80 caracteres. Considere dividir o texto em parágrafos menores para melhorias em acessibilidade.`,
      })
    }
  }, [children])
}
